@let formGroupValue = formGroup();
@if (formGroupValue) {
  <ng-container [formGroup]="formGroupValue">
    <mat-checkbox type="checkbox" [formControlName]="name()">{{label()}}</mat-checkbox>
    @if (help()) {
      <mat-icon [matTooltip]="help()" class="form-field__help-icon">help</mat-icon>
    }
    <mat-error>{{error()}}</mat-error>
  </ng-container>
}